import { SOCIAL_LABELS } from "src/types";

export const addAOPlatformToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  aggregation,
  campaignId,
  provider,
) => {
  const element = {
    key: `overlap-platform-${provider}-${campaignId}`,
    label: `overlap-platform-${provider}-${campaignId}`,
    provider,
    name: `Plaform - ${SOCIAL_LABELS[provider]}`,
    gridBoxType: "overlap-platform",
    section: `audience-overlap`,
    campaignId,
  };

  // applying saved template

  if (
    (!aggregation && campaignId === "aggregated") ||
    (aggregation && campaignId !== "aggregated")
  ) {
    newHiddenGridElements.push(element);
  } else if (savedTemplate?.length && !templateApplied) {
    if (savedTemplate.find((item) => item.i === element.label)) {
      newGridElements.push(element);
    } else {
      newHiddenGridElements.push(element);
    }
  } else {
    newGridElements.push(element);
  }
};
